import { getDefaultRequestState } from '@Features/utils/getDefaultRequestState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestFormHeader } from '@Types/index';

interface SalaryCertificateState {
  salaryCertificate: RequestFormHeader;
}

const initialState: SalaryCertificateState = {
  salaryCertificate: getDefaultRequestState(),
};

const salaryCertificateSlice = createSlice({
  name: 'salaryCertificate',
  initialState,
  reducers: {
    setSalaryCertificate: (
      state: SalaryCertificateState,
      action: PayloadAction<RequestFormHeader | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.salaryCertificate = getDefaultRequestState();
      } else {
        state.salaryCertificate = payload;
      }
    },
  },
});

const { actions } = salaryCertificateSlice;

export const salaryCertificateActions = {
  ...actions,
};

export default salaryCertificateSlice;
